/**
 * Richtwert-Kataloge (Demo-Stand, fachliche Quelle: LBK-Bewertungsrichtlinien
 * Okt. 2000 / Beispielprotokoll des Kunden). Produktiv pflegt der Landesverband
 * diese Werte über die Datenbank (Tabelle `kataloge`, versioniert je Jahr) —
 * diese Datei ist der Seed-Ausgangspunkt und die Referenz für Tests.
 */
export const BAUKLASSEN = [
    { k: 1, label: 'Bauklasse 1 – sehr einfach (Altmaterial, einwandig, ohne Fundament)', rw: 110 },
    { k: 2, label: 'Bauklasse 2 – einfach (einwandig, Punktfundament, Dachpappe)', rw: 220 },
    { k: 3, label: 'Bauklasse 3 – solide (Fundament, einfacher Holzfußboden)', rw: 340 },
    { k: 4, label: 'Bauklasse 4 – gut (doppelwandig, Betonfundament, eingezogene Decke)', rw: 430 },
    { k: 5, label: 'Bauklasse 5 – sehr gut (hochwertiger Ausbau, Ziegel/Zinkblech)', rw: 540 },
    {
        k: 6,
        label: 'Bauklasse 6 – aufwendig (Dämmung, Isolierfenster – nur Bestandsschutz)',
        rw: 650,
    },
];
/** Zustandsstufen → jährlicher Abschreibungssatz in % (Richtlinie: 2–5 %) */
export const ZUSTAND = [
    { label: 'Sehr gut – keine Mängel', satz: 2 },
    { label: 'Gut – leichte alterstypische Mängel', satz: 2.5 },
    { label: 'Mittel – deutliche Mängel', satz: 3.5 },
    { label: 'Schlecht – erhebliche Mängel', satz: 4.5 },
    { label: 'Sehr schlecht – baufällig', satz: 5 },
];
/** Obergrenze der Gesamtabschreibung (Restwert-Prinzip der Richtlinie) */
export const ABSCHREIBUNG_MAX = 90;
export const KATALOG = {
    neben: [
        { n: 'Zaun, Draht/Eisen/Stahl', e: 'm²', p: 15.5 },
        { n: 'Zaun, Holz einfach', e: 'm²', p: 18 },
        { n: 'Zaun, Holz hochwertig', e: 'm²', p: 25.5 },
        { n: 'Gartentür, Holz', e: 'Stück', p: 76.5 },
        { n: 'Gartentür, Eisen/Stahlrohr', e: 'Stück', p: 102.5 },
        { n: 'Stützmauer', e: 'm²', p: 31 },
        { n: 'Treppe', e: 'm', p: 10 },
        { n: 'Trockenmauer / Trockenbiotop', e: 'm²', p: 38 },
        { n: 'Wasserbecken / Wasserbehälter', e: 'Stück', p: 51 },
        { n: 'Wasserleitung', e: 'm', p: 11.5 },
        { n: 'Wasserzähler', e: 'Stück', p: 25.5 },
        { n: 'Pumpanlage', e: 'Stück', p: 153.5 },
        { n: 'Teich', e: 'm²', p: 7.5 },
        { n: 'Befestigte Fläche, einfacher Belag', e: 'm²', p: 7.5 },
        { n: 'Befestigte Fläche, Betonpflaster', e: 'm²', p: 12 },
        { n: 'Befestigte Fläche, Naturstein', e: 'm²', p: 18 },
        { n: 'Wegeeinfassung', e: 'm', p: 5 },
        { n: 'Kompostbehälter, Holz', e: 'Stück', p: 82 },
        { n: 'Kompostbehälter, Beton/Drahtgeflecht/Plastik', e: 'Stück', p: 128 },
        { n: 'Gewächshaus, einfach (Folie/Holz)', e: 'm²', p: 50 },
        { n: 'Gewächshaus, hochwertig (Glas/Alu)', e: 'm²', p: 200 },
        { n: 'Hochbeet', e: 'm²', p: 100 },
        { n: 'Frühbeet', e: 'm²', p: 50 },
        { n: 'Rankgerüst', e: 'm²', p: 12 },
        { n: 'Lärm-/Sichtschutzwand', e: 'm²', p: 25.5 },
        { n: 'Sonstige Nebenanlage', e: 'Stück', p: 0 },
    ],
    kulturen: [
        { n: 'Apfel (Halb-/Hochstamm, Busch)', e: 'Stück', p: 67 },
        { n: 'Apfel (Spindel/Spalier)', e: 'Stück', p: 43 },
        { n: 'Birne', e: 'Stück', p: 67 },
        { n: 'Zwetschge / Pflaume / Mirabelle', e: 'Stück', p: 57 },
        { n: 'Süßkirsche', e: 'Stück', p: 75 },
        { n: 'Sauerkirsche', e: 'Stück', p: 47 },
        { n: 'Pfirsich', e: 'Stück', p: 45 },
        { n: 'Aprikose', e: 'Stück', p: 46 },
        { n: 'Quitte', e: 'Stück', p: 52 },
        { n: 'Haselnuss (großfruchtig)', e: 'Stück', p: 36 },
        { n: 'Johannisbeere', e: 'Stück', p: 19 },
        { n: 'Jostabeere', e: 'Stück', p: 19 },
        { n: 'Stachelbeere', e: 'Stück', p: 20 },
        { n: 'Himbeere', e: 'm', p: 11 },
        { n: 'Brombeere', e: 'Stück', p: 17 },
        { n: 'Heidelbeere', e: 'Stück', p: 26 },
        { n: 'Weinrebe / Tafeltraube', e: 'Stück', p: 31.5 },
        { n: 'Kiwi', e: 'Stück', p: 20 },
        { n: 'Rhabarber / Meerrettich', e: 'Stück', p: 8 },
        { n: 'Spargel', e: 'Stück', p: 17 },
        { n: 'Erdbeeren', e: 'm²', p: 12 },
        { n: 'Gemüsefläche', e: 'm²', p: 2.5 },
        { n: 'Beetfläche', e: 'm²', p: 2.5 },
        { n: 'Sonstige Kultur', e: 'Stück', p: 0 },
    ],
    zier: [
        { n: 'Beet-/Zwergrose', e: 'Stück', p: 14, g: 'zg' },
        { n: 'Kletterrose', e: 'Stück', p: 21.5, g: 'zg' },
        { n: 'Hochstammrose', e: 'Stück', p: 23, g: 'zg' },
        { n: 'Klettergehölz (z. B. Wilder Wein)', e: 'Stück', p: 10.5, g: 'zg' },
        { n: 'Clematis / Blüh-Klettergehölz', e: 'Stück', p: 19.5, g: 'zg' },
        { n: 'Ziergehölz / Zierstrauch', e: 'Stück', p: 10.5, g: 'zg' },
        { n: 'Hochwertiger Zierstrauch (Flieder, Buchsbaum …)', e: 'Stück', p: 22, g: 'zg' },
        { n: 'Rhododendron / Azalee', e: 'Stück', p: 30.5, g: 'zg' },
        { n: 'Nadelgehölz (schwachwüchsig)', e: 'Stück', p: 18.5, g: 'zg' },
        { n: 'Hecke, einfach (Liguster, Hainbuche …)', e: 'm', p: 12, g: 'zg' },
        { n: 'Hecke, Blühsträucher', e: 'm', p: 19, g: 'zg' },
        { n: 'Hecke, hochwertig', e: 'm', p: 25, g: 'zg' },
        { n: 'Solitärstaude (Pfingstrose …)', e: 'Stück', p: 10.5, g: 'st' },
        { n: 'Stauden, flächig', e: 'm²', p: 15, g: 'st' },
        { n: 'Bodendecker', e: 'm²', p: 10, g: 'st' },
        { n: 'Zwiebelpflanzen, flächig', e: 'm²', p: 6, g: 'st' },
        { n: 'Rasen / Blumenwiese (max. ⅓ der Gartenfläche)', e: 'm²', p: 1, g: 'ra' },
        { n: 'Sonstige Zierbegrünung', e: 'Stück', p: 0, g: 'zg' },
    ],
};
/** Höchstwerte je Gruppe (Richtlinie Tabelle 4/5) */
export const CAPS = {
    zg: { label: 'Ziergehölze, Rosen, Hecken & Nadelgehölze', max: 500 },
    st: { label: 'Stauden & Zwiebelpflanzen', max: 300 },
};
/** Fallback, falls für das Bewertungsjahr kein Faktor gepflegt ist */
export const FAKTOR_DEFAULT = 1.0;
//# sourceMappingURL=catalogs.js.map